import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { AppMainComponent } from '../../../../app.main.component';
import { ConfigurationService } from 'src/app/configurations/configurationService';
import { MessageService } from 'primeng/api';
import { ObjectNames, Severity, Answer } from '../../constants/constants';
import data from '../../staticJSON/inventory-template.json';
import { TitleCasePipe } from '@angular/common';
import { CustomService } from '../../custom/custom.service';
import { ListService } from '../../custom/list/list.service';

@Component({
  selector: 'app-template',
  templateUrl: './template.component.html',
  styleUrls: ['./template.component.scss'],

})
export class TemplateComponent implements OnInit,OnChanges {

  @Input() templates = [];
  @Input() templateConfig: any;
  @Input() templateTypeId;
  @Input() sectionTypeId;
  @Input() allSections = [];
  sectionConfig: any;
  templateInventoryTemp=data;
  originalTemplates =[];
  availableInventoryLabels_item = [];
  selectedInventoryLabels_item = [];
  availableInventoryLabels_sales = [];
  selectedInventoryLabels_sales = [];
  availableInventoryLabels_inventory = [];
  selectedInventoryLabels_inventory = [];
  availableInventoryLabels_price = [];
  selectedInventoryLabels_price = [];
  availableInventoryLabels_finance = [];
  selectedInventoryLabels_finance = [];
  availableInventoryLabels_warehouse = [];
  selectedInventoryLabels_warehouse = [];
  availableInventoryLabels_other1 = [];
  selectedInventoryLabels_other1 = [];
  availableInventoryLabels_other2 = [];
  selectedInventoryLabels_other2 = [];
  availableInventoryLabels_other3 = [];
  selectedInventoryLabels_other3 = [];
  selectedInventoryCheck1 = true;
  selectedInventoryCheck2 = true;
  selectedInventoryCheck3 = true;
  selectedInventoryCheck4 = true;
  selectedInventoryCheck5 = true;
  selectedInventoryCheck6 = true;
  selectedInventoryCheck7 = true;
  selectedInventoryCheck8 = true;
  selectedInventoryCheck9 = true;
  displayEditInventoryTemplate: boolean = false;
  answertypeConstants = Answer;
  allCustomFieldTypes = [];
  allModules: any = [];
  inventoryObjId;
  allCustomFields = [];
  customFieldData = [];
  templateSections = [];
  isBundle: boolean=false;
  isKit: boolean=false;

  constructor(private app: AppMainComponent, private service: ConfigurationService, private messageService: MessageService,
    private titlecasePipe: TitleCasePipe, private customService: CustomService, private customfieldService: ListService) { }

  ngOnInit(): void {
    this.getModules();
    this.customService.getCustom().subscribe(field => {
      if(field){
        this.getModules();
        this.loadConfigurations('product');
      }
    })
  }

  ngOnChanges(){
    this.originalTemplates= JSON.parse(JSON.stringify(this.templates));
  }

  hideDialog() {
    this.getModules();
    this.templates=this.originalTemplates;
    this.availableInventoryLabels_item = [];
    this.selectedInventoryLabels_item = [];
    this.availableInventoryLabels_inventory = [];
    this.selectedInventoryLabels_inventory = [];
    this.availableInventoryLabels_sales = [];
    this.selectedInventoryLabels_sales = [];
    this.availableInventoryLabels_finance = [];
    this.selectedInventoryLabels_finance = [];
    this.availableInventoryLabels_warehouse = [];
    this.selectedInventoryLabels_warehouse = [];
    this.availableInventoryLabels_other1 = [];
    this.selectedInventoryLabels_other1 = [];
    this.availableInventoryLabels_other2 = [];
    this.selectedInventoryLabels_other2 = [];
    this.availableInventoryLabels_other3 = [];
    this.selectedInventoryLabels_other3 = [];
    this.selectedInventoryCheck1 = false;
    this.selectedInventoryCheck2 = false;
    this.selectedInventoryCheck3 = false;
    this.selectedInventoryCheck4 = false;
    this.selectedInventoryCheck5 = false;
    this.selectedInventoryCheck6 = false;
    this.selectedInventoryCheck7 = false;
    this.selectedInventoryCheck8 = false;
    this.selectedInventoryCheck9 = false;
    this.isBundle=false;
    this.isKit=false;
  }

  getModules() {
    this.customfieldService.getAllModules().subscribe(modules => {
      this.allModules = modules;
      const obj = this.allModules.filter(obj => obj.name == ObjectNames.productConstants.productFieldName)[0];
      this.inventoryObjId = obj.id;
      this.getCustomFieldTypes(obj.id);
    });
  }

  getCustomFieldTypes(objectId) {
    this.customfieldService.getAllCustomFieldTypes(objectId).then(fldtyps => {
      this.allCustomFieldTypes = fldtyps;
      this.loadCustomFields();
    });
  }

  loadCustomFields() {
    this.customfieldService.getAllCustomFields(this.inventoryObjId).then(fields => {
      this.customFieldData = [];
      this.allCustomFields = [];
      if (fields && fields.length > 0) {
        for (let l of fields) {
          let eachRecord = {
            id: Number(l.id + ""),
            name: l.name,
            module: this.allModules.find(el => el.id == l.objectId)?.name,
            formControl: this.allCustomFieldTypes.find(el => el.id == l.formControlId)?.name,
            formControlId: l.formControlId,
            isRequired: l.isRequired,
            statusId: l.statusId,
            statusName: l.status.name,
            section: l.section,
            configurationId: l.configurationId,
            isEdit: l.isEdit,
            isDelete: l.isDelete,
            pickupList: l.pickListValues ? JSON.stringify(l.pickListValues) : l.pickListValues
          }
          this.customFieldData.push(eachRecord);
        }
      }
      this.allCustomFields = this.customFieldData;
    });
  }

  showEditInventoryTemplate(c) {
    this.templateInventoryTemp = c;
    if (c.templateName == 'Inventory Item_template') {
      this.templateSections = this.allSections.filter(s => (s.typeId == c.producttypeId && s.isActive));
      this.availableInventoryLabels_item = this.templateInventoryTemp.labels_item;
      this.selectedInventoryLabels_item = this.templateInventoryTemp.labels_item;
      this.availableInventoryLabels_inventory = this.templateInventoryTemp.labels_attributes;
      this.selectedInventoryLabels_inventory = this.templateInventoryTemp.labels_attributes;
      this.availableInventoryLabels_sales = this.templateInventoryTemp.labels_purchasesales;
      this.selectedInventoryLabels_sales = this.templateInventoryTemp.labels_purchasesales;
      this.availableInventoryLabels_finance = this.templateInventoryTemp.labels_finance;
      this.selectedInventoryLabels_finance = this.templateInventoryTemp.labels_finance;
      this.availableInventoryLabels_warehouse = this.templateInventoryTemp.labels_warehouse;
      this.selectedInventoryLabels_warehouse = this.templateInventoryTemp.labels_warehouse;
      this.availableInventoryLabels_other1 = this.templateInventoryTemp.labels_inv_other1;
      this.selectedInventoryLabels_other1 = this.templateInventoryTemp.labels_inv_other1;
      this.availableInventoryLabels_other2 = this.templateInventoryTemp.labels_inv_other2;
      this.selectedInventoryLabels_other2 = this.templateInventoryTemp.labels_inv_other2;
      this.availableInventoryLabels_other3 = this.templateInventoryTemp.labels_inv_other3;
      this.selectedInventoryLabels_other3 = this.templateInventoryTemp.labels_inv_other3;
    } else if (c.templateName == 'Service_template') {
      this.templateSections = this.allSections.filter(s => (s.typeId == c.producttypeId && s.isActive));
      this.availableInventoryLabels_item = this.templateInventoryTemp.labels_service;
      this.selectedInventoryLabels_item = this.templateInventoryTemp.labels_service;
      this.availableInventoryLabels_other1 = this.templateInventoryTemp.labels_service_other1;
      this.selectedInventoryLabels_other1 = this.templateInventoryTemp.labels_service_other1;
      this.availableInventoryLabels_other2 = this.templateInventoryTemp.labels_service_other2;
      this.selectedInventoryLabels_other2 = this.templateInventoryTemp.labels_service_other2;
      this.availableInventoryLabels_other3 = this.templateInventoryTemp.labels_service_other3;
      this.selectedInventoryLabels_other3 = this.templateInventoryTemp.labels_service_other3;
    } else if (c.templateName == 'Non Inventory Item_template') {
      this.templateSections = this.allSections.filter(s => (s.typeId == c.producttypeId && s.isActive));
      const priceTierSection = this.templateSections.filter(s=> s.name=='Price Tier')[0];
      const index = this.templateSections.indexOf(priceTierSection);
      this.templateSections.splice(index,1);
      this.availableInventoryLabels_item = this.templateInventoryTemp.labels_nvinfo;
      this.selectedInventoryLabels_item = this.templateInventoryTemp.labels_nvinfo;
      this.availableInventoryLabels_other1 = this.templateInventoryTemp.labels_noninven_other1;
      this.selectedInventoryLabels_other1 = this.templateInventoryTemp.labels_noninven_other1;
      this.availableInventoryLabels_other2 = this.templateInventoryTemp.labels_noninven_other2;
      this.selectedInventoryLabels_other2 = this.templateInventoryTemp.labels_noninven_other2;
      this.availableInventoryLabels_other3 = this.templateInventoryTemp.labels_noninven_other3;
      this.selectedInventoryLabels_other3 = this.templateInventoryTemp.labels_noninven_other3;
    }else if(c.templateName == 'Kit_template'){
      this.templateSections = this.allSections.filter(s => (s.typeId == c.producttypeId && s.isActive));
      this.isKit = true;
      this.availableInventoryLabels_item = this.templateInventoryTemp.labels_kitinfo;
      this.selectedInventoryLabels_item = this.templateInventoryTemp.labels_kitinfo;
      this.availableInventoryLabels_inventory = this.templateInventoryTemp.labels_itemlist;
      this.selectedInventoryLabels_inventory = this.templateInventoryTemp.labels_itemlist;
      this.availableInventoryLabels_sales = this.templateInventoryTemp.labels_finance;
      this.selectedInventoryLabels_sales = this.templateInventoryTemp.labels_finance;
      this.availableInventoryLabels_other1 = this.templateInventoryTemp.labels_kit_other1;
      this.selectedInventoryLabels_other1 = this.templateInventoryTemp.labels_kit_other1;
      this.availableInventoryLabels_other2 = this.templateInventoryTemp.labels_kit_other2;
      this.selectedInventoryLabels_other2 = this.templateInventoryTemp.labels_kit_other2;
      this.availableInventoryLabels_other3 = this.templateInventoryTemp.labels_kit_other3;
      this.selectedInventoryLabels_other3 = this.templateInventoryTemp.labels_kit_other3;
    }else {
      this.templateSections = this.allSections.filter(s => (s.typeId == c.producttypeId && s.isActive));
      this.isBundle = true;
      this.availableInventoryLabels_item = this.templateInventoryTemp.labels_bundle;
      this.selectedInventoryLabels_item = this.templateInventoryTemp.labels_bundle;
      this.availableInventoryLabels_inventory = this.templateInventoryTemp.labels_prdinfo;
      this.selectedInventoryLabels_inventory = this.templateInventoryTemp.labels_prdinfo;
      this.availableInventoryLabels_other1 = this.templateInventoryTemp.labels_bundle_other1;
      this.selectedInventoryLabels_other1 = this.templateInventoryTemp.labels_bundle_other1;
      this.availableInventoryLabels_other2 = this.templateInventoryTemp.labels_bundle_other2;
      this.selectedInventoryLabels_other2 = this.templateInventoryTemp.labels_bundle_other2;
      this.availableInventoryLabels_other3 = this.templateInventoryTemp.labels_bundle_other3;
      this.selectedInventoryLabels_other3 = this.templateInventoryTemp.labels_bundle_other3;
    }
    //load custom fields
    this.allCustomFields.forEach(fld => {
      if(fld.section?.typeId==this.templateInventoryTemp.producttypeId){
        let temp = {}
        if (fld.isEdit) {
          temp = {
            code: fld.name,
            id: fld.id,
            isChecked: false,
            formControl: fld.formControl,
            formControlId: fld.formControlId,
            isMovable: true,
            isShowForDrag: true,
            labelname: fld.name,
            name: fld.name,
            sectionId: fld.section.id,
            custom: true,
            pickupList: fld.pickupList,
            isRequired: fld.isRequired
          }
          let sectionData = this.allSections.find(section => section.id == fld?.section?.id);
          if (sectionData) {
            if (!this.templateInventoryTemp[sectionData?.code]?.find(labelData => labelData.name == fld.name && labelData.sectionId == fld.section.id)) {
              this.templateInventoryTemp[sectionData?.code]?.push(temp);
            }
          }
        }
      }
     
    });
    this.displayEditInventoryTemplate = true;
    if (this.selectedInventoryLabels_item) {
      const item = this.selectedInventoryLabels_item.filter(i => i.isChecked);
      if (item.length > 0) {
        this.selectedInventoryCheck1 = true;
      } else {
        this.selectedInventoryCheck1 = false;
      }
    }
    if (this.selectedInventoryLabels_inventory) {
      const sales = this.selectedInventoryLabels_inventory.filter(i => i.isChecked);
      if (sales.length > 0) {
        this.selectedInventoryCheck2 = true;
      } else {
        this.selectedInventoryCheck2 = false;
      }
    }
    if (this.selectedInventoryLabels_sales) {
      const inventory = this.selectedInventoryLabels_sales.filter(i => i.isChecked);
      if (inventory.length > 0) {
        this.selectedInventoryCheck3 = true;
      } else {
        this.selectedInventoryCheck3 = false;
      }
    }
    if (this.selectedInventoryLabels_price) {
      const price = this.selectedInventoryLabels_price.filter(i => i.isChecked);
      if (price.length > 0) {
        this.selectedInventoryCheck4 = true;
      } else {
        this.selectedInventoryCheck4 = false;
      }
    }
    if (this.selectedInventoryLabels_finance) {
      const finance = this.selectedInventoryLabels_finance.filter(i => i.isChecked);
      if (finance.length > 0) {
        this.selectedInventoryCheck9 = true;
      } else {
        this.selectedInventoryCheck9 = false; 
      }
    }
    if (this.selectedInventoryLabels_warehouse) {
      const warehouse = this.selectedInventoryLabels_warehouse.filter(i => i.isChecked);
      if (warehouse.length > 0) {
        this.selectedInventoryCheck5 = true;
      } else {
        this.selectedInventoryCheck5 = false;
      }
    }
    if (this.selectedInventoryLabels_other1) {
      const other1 = this.selectedInventoryLabels_other1.filter(i => i.isChecked);
      if (other1.length > 0) {
        this.selectedInventoryCheck6 = true;
      } else {
        this.selectedInventoryCheck6 = false;
      }
    }
    if (this.selectedInventoryLabels_other2) {
      const other2 = this.selectedInventoryLabels_other2.filter(i => i.isChecked);
      if (other2.length > 0) {
        this.selectedInventoryCheck7 = true;
      } else {
        this.selectedInventoryCheck7 = false;
      }

    }
    if (this.selectedInventoryLabels_other3) {
      const other3 = this.selectedInventoryLabels_other3.filter(i => i.isChecked);
      if (other3.length > 0) {
        this.selectedInventoryCheck8 = true;
      } else {
        this.selectedInventoryCheck8 = false;
      }
    }
  }

  updateInventoryTemplate(template) {
    this.templateInventoryTemp.updatedDate = new Date().toISOString();
    this.templateInventoryTemp.updatedBy = this.app.userId;
    this.templateInventoryTemp.updatedSource = this.app.userIP;
    this.templates.forEach(element => {
      if (template.id == element.id) {
        element = this.templateInventoryTemp;
      }
    });
    this.templateConfig.configJSONValue = JSON.stringify(this.templates);
    this.service.updateConfiguration(this.templateConfig).then(() => {
      this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Template updated successfully...' });
      this.displayEditInventoryTemplate = false;
      this.loadConfigurations('product');
    }).catch(() => {
      this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
    });
  }

  loadConfigurations(moduleName) {
    this.service.getConfigurationByModuleName(moduleName).subscribe(configs => {
      //templates
      this.templateConfig = configs.filter(s => (s.name == ObjectNames.productConstants.Inventory_Template_Object && s.categoryId==6))[0];
      this.templates = JSON.parse(this.templateConfig.configurationDetails[0].configJSONValue);
      this.originalTemplates = JSON.parse(JSON.stringify(this.templates));
      //sections
      this.sectionConfig = configs.filter(s => s.name == ObjectNames.customConstants.Inventory_Section_Object)[0];
      this.allSections = JSON.parse(this.sectionConfig.configurationDetails[0].configJSONValue);
    });
  }


  selectedInventoryRow1(value) {
    if (value) {
      for (let s of this.availableInventoryLabels_item) {
        s.isChecked = true;
      }
    } else {
      for (let s of this.availableInventoryLabels_item) {
        if (s.isMovable) {
          s.isChecked = false;
        }
      }
    }
  }

  selectedInventoryRow2(value) {
    if (value) {
      for (let s of this.availableInventoryLabels_inventory) {
        s.isChecked = true;
      }
    } else {
      for (let s of this.availableInventoryLabels_inventory) {
        if (s.isMovable) {
          s.isChecked = false;
        }
      }
    }
  }

  selectedInventoryRow3(value) {
    if (value) {
      for (let s of this.availableInventoryLabels_sales) {
        s.isChecked = true;
      }
    } else {
      for (let s of this.availableInventoryLabels_sales) {
        if (s.isMovable) {
          s.isChecked = false;
        }
      }
    }
  }

  selectedInventoryRow4(value) {
    if (value) {
      for (let s of this.availableInventoryLabels_price) {
        s.isChecked = true;
      }
    } else {
      for (let s of this.availableInventoryLabels_price) {
        if (s.isMovable) {
          s.isChecked = false;
        }
      }
    }
  }

  selectedInventoryRow5(value) {
    if (value) {
      for (let s of this.availableInventoryLabels_warehouse) {
        s.isChecked = true;
      }
    } else {
      for (let s of this.availableInventoryLabels_warehouse) {
        if (s.isMovable) {
          s.isChecked = false;
        }
      }
    } 
  }

  selectedInventoryRow6(value) {
    if (value) {
      for (let s of this.availableInventoryLabels_other1) {
        s.isChecked = true;
      }
    } else {
      for (let s of this.availableInventoryLabels_other1) {
        if (s.isMovable) {
          s.isChecked = false;
        }
      }
    }
  }

  selectedInventoryRow7(value) {
    if (value) {
      for (let s of this.availableInventoryLabels_other2) {
        s.isChecked = true;
      }
    } else {
      for (let s of this.availableInventoryLabels_other2) {
        if (s.isMovable) {
          s.isChecked = false;
        }
      }
    }
  }

  selectedInventoryRow8(value) {
    if (value) {
      for (let s of this.availableInventoryLabels_other3) {
        s.isChecked = true;
      }
    } else {
      for (let s of this.availableInventoryLabels_other3) {
        if (s.isMovable) {
          s.isChecked = false;
        }
      }
    }
  }

  selectedInventoryRow9(value) {
    if (value) {
      for (let s of this.availableInventoryLabels_finance) {
        s.isChecked = true;
      }
    } else {
      for (let s of this.availableInventoryLabels_finance) {
        if (s.isMovable) {
          s.isChecked = false;
        }
      }
    }
  }

  setInventorySection(value) {
    //const filteredSection = this.allSections.filter(s => s.id == value.sectionId)[0];
    if (value) {
      this.selectedInventoryCheck1 = true;
    } else {
      // const availableFields = this.templateInventoryTemp.availableInventoryLabels_item.filter(f => f.sectionId == value.sectionId);
      const checkedFields = this.availableInventoryLabels_item.filter(c => c.isChecked);
      const unCheckedFields = this.availableInventoryLabels_item.filter(c => !c.isChecked);
      if (value && (this.availableInventoryLabels_item.length-2) == checkedFields.length) {
        this.selectedInventoryCheck1 = true;
      } else if (!value && (this.availableInventoryLabels_item.length-2) == unCheckedFields.length) {
        this.selectedInventoryCheck1 = false;
      }
    }
  }

  setAttributeSection(value){
    if (value) {
      this.selectedInventoryCheck2 = true;
    } else {
      // const availableFields = this.templateInventoryTemp.availableInventoryLabels_item.filter(f => f.sectionId == value.sectionId);
      const checkedFields = this.availableInventoryLabels_inventory.filter(c => c.isChecked);
      const unCheckedFields = this.availableInventoryLabels_inventory.filter(c => !c.isChecked);
      if (value && this.availableInventoryLabels_inventory.length == checkedFields.length) {
        this.selectedInventoryCheck2 = true;
      } else if (!value && this.availableInventoryLabels_inventory.length == unCheckedFields.length) {
        this.selectedInventoryCheck2 = false;
      }
    }
  }

  setSalesSection(value){
    if (value) {
      this.selectedInventoryCheck3 = true;
    } else {
      const checkedFields = this.availableInventoryLabels_sales.filter(c => c.isChecked);
      const unCheckedFields = this.availableInventoryLabels_sales.filter(c => !c.isChecked);
      if (value && this.availableInventoryLabels_sales.length == checkedFields.length) {
        this.selectedInventoryCheck3 = true;
      } else if (!value && this.availableInventoryLabels_sales.length == unCheckedFields.length) {
        this.selectedInventoryCheck3 = false;
      }
    }
  }

  setFinanceSection(value){
    if (value) {
      this.selectedInventoryCheck5 = true;
    } else {
      const checkedFields = this.availableInventoryLabels_warehouse.filter(c => c.isChecked);
      const unCheckedFields = this.availableInventoryLabels_warehouse.filter(c => !c.isChecked);
      if (value && this.availableInventoryLabels_warehouse.length == checkedFields.length) {
        this.selectedInventoryCheck5 = true;
      } else if (!value && this.availableInventoryLabels_warehouse.length == unCheckedFields.length) {
        this.selectedInventoryCheck5 = false;
      }
    }
  }

  setWarehouseSection(value){
    if (value) {
      this.selectedInventoryCheck9 = true;
    } else {
      const checkedFields = this.availableInventoryLabels_finance.filter(c => c.isChecked);
      const unCheckedFields = this.availableInventoryLabels_finance.filter(c => !c.isChecked);
      if (value && this.availableInventoryLabels_finance.length == checkedFields.length) {
        this.selectedInventoryCheck9 = true;
      } else if (!value && this.availableInventoryLabels_finance.length == unCheckedFields.length) {
        this.selectedInventoryCheck9 = false;
      }
    }
  }

  setOther1Section(value){
    if (value) {
      this.selectedInventoryCheck6 = true;
    } else {
      const checkedFields = this.availableInventoryLabels_other1.filter(c => c.isChecked);
      const unCheckedFields = this.availableInventoryLabels_other1.filter(c => !c.isChecked);
      if (value && this.availableInventoryLabels_other1.length == checkedFields.length) {
        this.selectedInventoryCheck6 = true;
      } else if (!value && this.availableInventoryLabels_other1.length == unCheckedFields.length) {
        this.selectedInventoryCheck6 = false;
      }
    }
  }

  setOther2Section(value){
    if (value) {
      this.selectedInventoryCheck7 = true;
    } else {
      const checkedFields = this.availableInventoryLabels_other2.filter(c => c.isChecked);
      const unCheckedFields = this.availableInventoryLabels_other2.filter(c => !c.isChecked);
      if (value && this.availableInventoryLabels_other2.length == checkedFields.length) {
        this.selectedInventoryCheck7 = true;
      } else if (!value && this.availableInventoryLabels_other2.length == unCheckedFields.length) {
        this.selectedInventoryCheck7 = false;
      }
    }
  }

  setOther3Section(value){
    if (value) {
      this.selectedInventoryCheck8 = true;
    } else {
      const checkedFields = this.availableInventoryLabels_other3.filter(c => c.isChecked);
      const unCheckedFields = this.availableInventoryLabels_other3.filter(c => !c.isChecked);
      if (value && this.availableInventoryLabels_other3.length == checkedFields.length) {
        this.selectedInventoryCheck8 = true;
      } else if (!value && this.availableInventoryLabels_other3.length == unCheckedFields.length) {
        this.selectedInventoryCheck8 = false;
      }
    }
  }
}
